import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { environment } from '../../environments/environment';

export function getSociedadActivaByDOM(documentLocation: Location | Location): number {
  // 1. Detectar parámetro por URL (Solo en desarrollo local, para simulación rápida sin tocar hosts)
  if (!environment.production) {
    const urlParams = new URLSearchParams(documentLocation.search);
    const forcedSociedad = urlParams.get('sociedad');
    if (forcedSociedad) {
      return Number(forcedSociedad);
    }
  }

  // 2. Detectar por dominio/subdominio
  const hostname = documentLocation.hostname;
  
  const domainMap: { [key: string]: number } = {
    // Producción
    'rs.techo.com.bo': 1200,
    'rs.elpahuichi.com.bo': 1300,
    'rs.monumental.com.bo': 1600,
    'rs.pilatsrl.com': 1700,
    'rs.nuevasantacruz.com': 1800,
    'rs.casamia-ltda.com': 2400,

    // Desarrollo
    'rs-dev.techo.com.bo': 1200,
    'rs-dev.elpahuichi.com.bo': 1300,
    'rs-dev.monumental.com.bo': 1600,
    'rs-dev.pilatsrl.com': 1700,
    'rs-dev.nuevasantacruz.com': 1800,
    'rs-dev.casamia-ltda.com': 2400,
    
    // Local (Opcional, en caso de usar archivo hosts)
    'techo.test': 1200,
    'elpahuichi.test': 1300,
    'monumental.test': 1600,
    'pilat.test': 1700,
    'nuevasantacruz.test': 1800,
    'casamia.test': 2400
  };

  // Retorna la sociedad basada en el dominio, o usa la de environment si no encuentra coincidencia (ej: localhost)
  return domainMap[hostname] || environment.sociedad; 
}

@Injectable({ providedIn: 'root' })
export class ConfigService {
  constructor(@Inject(DOCUMENT) private document: Document) {}

  public getSociedadActiva(): number {
    return getSociedadActivaByDOM(this.document.location);
  }

  /** Actualiza el favicon del documento según el código de sociedad. */
  public setFavicon(sociedad: number): void {
    const link: HTMLLinkElement =
      (this.document.querySelector("link[rel~='icon']") as HTMLLinkElement) ||
      this.document.createElement('link');
    link.rel = 'icon';
    link.type = 'image/png';
    link.href = `favicon/${sociedad}.png`;
    this.document.head.appendChild(link);
  }
}
